import { array, struct } from 'io-ts/Decoder';

import { Id as BuilderId } from '../../../builder/Id';

export const Request = struct({
	builderIds: array(BuilderId),
});
